import "./FormStyles.css";
import React, { useRef, useState } from "react";
import emailjs from '@emailjs/browser';

export const ContactForm = () => {
  const form = useRef();
  const [responseMessage, setResponseMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    const name = form.current.user_name.value.trim();
    const email = form.current.user_email.value.trim();
    const message = form.current.message.value.trim();

    if (!name || !email || !message) {
      setResponseMessage('Please fill in all fields.');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setResponseMessage('Invalid email address.');
      return;
    }

    emailjs.sendForm('service_oeagigr', 'template_eqej42p', form.current, '9xbAUBuig-EqOafnD')
      .then((result) => {
        console.log(result.text);
        setResponseMessage('Email sent successfully.');
      }, (error) => {
        console.log(error.text);
        setResponseMessage('Failed to send email.');
      });
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Message</label>
      <textarea name="message" />
      <label id="helpContactForm">{responseMessage}</label>
      <input type="submit" value="Send" />
    </form>
  );
};
